angular.module('signalflowv2').service('signalFlowV2StreamerArtifacts', [
    '$window',
    function ($window) {
        return $window.signalfx.streamer.SignalFlow;
    },
]);
